export const related = [
  '/puzzles/wear-em-wash-em-laundromat',
  '/puzzles/atlantis-code-the-park',
  '/puzzles',
];
export const quickAnswer =
  'Enter 1213 at the register inside Urban Fresh in West Incursion Zone.';
export const sourceIds = ['powerpyx-hideouts'];

## Where Is Urban Fresh?

Find the Urban Fresh shop in West Incursion Zone, then locate the register inside.

## Urban Fresh Code

Use **1213**. Confirm the complete input at the register.

## What Happens After Entering 1213?

The concealed wall opens to a Secret Hideout. Enter the room and collect the health-upgrade item.

## Code Not Working?

Check that the shop is Urban Fresh, rather than one of the Atlantis restaurants. Recheck all four digits before submitting.
